import { jsxs as e, jsx as C } from "react/jsx-runtime";
const t = ({ className: o }) => /* @__PURE__ */ e(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: o,
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M5.83335 5.41665H13.9584C15.7139 5.41665 16.5917 5.41665 17.2223 5.83797C17.4953 6.02037 17.7296 6.25475 17.912 6.52772C18.3334 7.15828 18.3334 7.82774 18.3334 9.58331M10 5.41665L9.47216 4.36092C9.03484 3.48629 8.63521 2.60591 7.66607 2.24249C7.2416 2.08331 6.7567 2.08331 5.78691 2.08331C4.27319 2.08331 3.51632 2.08331 2.94841 2.40024C2.54358 2.62616 2.20954 2.9602 1.98362 3.36503C1.66669 3.93295 1.66669 4.68981 1.66669 6.20354V8.74998C1.66669 12.6784 1.66669 14.6425 2.88708 15.8629C4.01794 16.9938 5.78746 17.0767 9.16669 17.0828H10",
          stroke: "#0C0A09",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M18.3334 17.9167L16.5441 16.1274M16.5441 16.1274C16.6396 16.032 16.7283 15.9298 16.8095 15.8217C17.1684 15.3441 17.381 14.7505 17.381 14.1071C17.381 12.5292 16.1018 11.25 14.5238 11.25C12.9459 11.25 11.6667 12.5292 11.6667 14.1071C11.6667 15.6851 12.9459 16.9643 14.5238 16.9643C15.3128 16.9643 16.0271 16.6445 16.5441 16.1274Z",
          stroke: "#0C0A09",
          strokeLinecap: "round"
        }
      )
    ]
  }
);
export {
  t as BrowseFilesIcon
};
